import {useState} from "react";
import {useQuery} from "@tanstack/react-query";
import Breadcrumbs from "../Breadcrumbs";
import {getPromotions} from "../../../api/news";
import PromotionsList from "./PromotionsList";

export enum PromotionTabs {
    ACTIONS = "ACTIONS",
    RULES = "RULES",
}

export default function Promotions({isEmbedded = false}: { isEmbedded?: boolean }) {
    const [tab, setTab] = useState<PromotionTabs>(PromotionTabs.ACTIONS);

    const {data} = useQuery({
        queryKey: [...["promotions"]],
        queryFn: () => getPromotions(),
    });

    const {posts: promotions, breadcrumbs} = data || {};

    const getSortedAndFilteredPromotions = () => {
        return (promotions || []).sort((a, b) => Date.parse(b.news_date) - Date.parse(a.news_date)).filter(promotion => {
            switch (tab) {
                case PromotionTabs.ACTIONS:
                    return promotion.type_id == 1;
                case PromotionTabs.RULES:
                    return promotion.type_id == 2;
            }
        })
    };

    if (isEmbedded) {
        return (<section className="stocks pt">
                <PromotionsList promotions={getSortedAndFilteredPromotions()} tab={tab} setTab={setTab}/>
            </section>)
    }

    return (
        <main className="main-stocks">
            <section className="stocks pt">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <Breadcrumbs breadcrumbs={breadcrumbs || []}/>
                        </div>
                    </div>
                    <PromotionsList promotions={getSortedAndFilteredPromotions()} tab={tab} setTab={setTab}/>
                </div>
            </section>
        </main>
    );
}
